import { Locale } from 'shared/i18n/interface'
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

import { queryUrl, QUERY_KEY } from '~/app/features/Gallery/components/Header/ActionHeader/components/Favorites/queryUrl'
import type { MTT } from 'shared/types/vp/mtt'

type QueryKey = MTT.Queries.Url.UrlQueryKey

export const useQueryUrl = (
  locale: Locale,
  urlId: string,
  options?: Omit<UseQueryOptions<string, Error, string, QueryKey>, 'queryKey'>,
): UseQueryResult<string, Error> =>
  useQuery<string, Error, string, QueryKey>({
    queryKey: [
      QUERY_KEY,
      {
        locale,
        urlId,
      },
    ],
    queryFn: queryUrl,
    ...options,
  })
